import { applyMinMax } from './applyMinMax';

export const convertHexStringToRGBA = (hex: string, opacity?: number): string => {
  const r = parseInt(hex.slice(1, 3), 16);
  const g = parseInt(hex.slice(3, 5), 16);
  const b = parseInt(hex.slice(5, 7), 16);

  if (opacity !== undefined) {
    return `rgba(${r}, ${g}, ${b}, ${applyMinMax({ value: opacity })})`;
  }
  return `rgb(${r}, ${g}, ${b})`;
};
